import CountUp from 'react-countup';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';

import { TextToolTip } from '@/components/shared/TextToolTip';
import { Web3Wallet } from '@/components/shared/web3-wallet/web3-wallet';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { PATHS } from '@/constants/page-paths';
import { useAuth } from '@/lib/hooks/useAuth';
import { useTwinVault } from '@/lib/hooks/useTwinVault';
import TwinCoin from '@/pages/profile/components/TwinCoin';
import { useSettingsStore } from '@/store';
import { ProfileDropdown } from '../../ProfileDropdown';
import { MobileMenu } from './MobileMenu';

export const RightNav = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { vaultData, isLoading } = useTwinVault();
  const { settings } = useSettingsStore();

  const tokenEnabled = settings?.app?.isTokenEnabled ?? false;

  return (
    <div className="flex items-center justify-between gap-2 lg:gap-4 h-full">
      {isAuthenticated ? (
        <>
          {isLoading ? (
            <Skeleton className="w-20 h-6" />
          ) : (
              <div className="flex justify-center items-center px-2 py-1 gap-1 sm:gap-2 rounded-full bg-secondary text-secondary-foreground">
                <Link to={`${PATHS.PROFILE}/?tab=vault`}>
                  <div className="flex gap-1 items-center sm:gap-2">
                    <TwinCoin />
                    <div className="font-semibold text-sm">
                      <CountUp
                        end={
                          parseFloat(vaultData?.twinPoint) as unknown as number
                        }
                        decimals={0}
                        duration={0.5}
                      />
                    </div>
                  </div>
                </Link>
                <TextToolTip label="Buy Points" side="bottom">
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(PATHS.BUY_POINTS);
                    }}
                    className="h-6 w-6 px-1 rounded-full"
                    data-testid="buy-point-button-right-nav"
                  >
                    <AiOutlinePlus />
                  </Button>
                </TextToolTip>
              </div>
          )}
          {tokenEnabled && (
            <div className="hidden sm:block">
              <Web3Wallet />
            </div>
          )}
          <ProfileDropdown />
          <MobileMenu />
        </>
      ) : (
        <div
          className="flex items-center gap-2 md:gap-4"
          data-testid="sign-in-right-nav"
        >
          <Link to={PATHS.SIGN_IN}>Sign-in</Link>
          <MobileMenu />
        </div>
      )}
    </div>
  );
};
